module.exports = __webpack_public_path__ + "static/media/ic-NDA.15be43de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-NDA.svg
// module id = 1288
// module chunks = 17